import React from 'react';
import { Wrapper, TitleWrapper, ButtonsWrapper } from './ProjectHeader.styles';
import { ApButtonIcon } from '@alixpartners/ui-components';
import { SortMenu } from '../SortMenu';
import { SearchMenu } from '../SearchMenu';
import useResizeObserver from 'use-resize-observer';

export const ProjectHeader = ({
	onSortChange,
	searchOptions,
	currencySymbol,
	onSearch,
	onAddNew,
}) => {
	const { ref, width = 0 } = useResizeObserver({
		box: 'border-box',
	});

	return (
		<Wrapper innerRef={ref}>
			<TitleWrapper>Project taxonomy</TitleWrapper>
			<ButtonsWrapper>
				<ApButtonIcon iconName="baseline_add" onClick={onAddNew} />
				<SearchMenu
					onSearch={onSearch}
					offsetRight={-52}
					width={width}
					options={searchOptions}
					currencySymbol={currencySymbol}
				/>
				<SortMenu onChange={onSortChange} />
			</ButtonsWrapper>
		</Wrapper>
	);
};

export default ProjectHeader;
